import { GMOUDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadGmou = createAction('[Gmou] Load Gmou');

export const loadGmouSuccess = createAction(
  '[Gmou] Load Gmou Success',
  props<{ gmou: GMOUDto[] }>()
);

export const loadGmouFailure = createAction(
  '[Gmou] Load Gmou Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addGmou = createAction(
  '[Gmou] Add Gmou',
  props<{ newGmou: GMOUDto }>()
);

export const addGmouSuccess = createAction(
  '[Gmou] Add Gmou Success',
  props<{ newGmou: GMOUDto }>()
);

export const addGmouFailure = createAction(
  '[Gmou] Add Gmou Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchGmouRecord = createAction(
  '[Gmou] Search  Gmou Record',
  props<{ query: string }>()
);

/**
 * Update Gmou Collection Actions
 */
export const updateGmou = createAction(
  '[Gmou] Update Gmou',
  props<{ updateGmou: GMOUDto }>()
);

export const updateGmouSuccess = createAction(
  '[Gmou] Update Gmou Success',
  props<{ updateGmou: GMOUDto }>()
);

export const updateGmouFailure = createAction(
  '[Gmou] Update Gmou Failure',
  props<{ error: any }>()
);

/**
 * Remove Gmou Collection Actions
 */
export const removeGmou = createAction(
  '[Gmou] Remove Gmou',
  props<{ ids: string }>()
);

export const removeGmouSuccess = createAction(
  '[Gmou] Remove Gmou Success',
  props<{ ids: string }>()
);

export const removeGmouFailure = createAction(
  '[Gmou] Remove Gmou Failure',
  props<{ error: any }>()
);
